import { SafeAny } from '@/common/types';
import { axiosInstance, i18n, useGlobalErrorOverlay } from '@/common/utils';

export const claimStudy = async (
  { rootState }: SafeAny,
  payload: { sleepStudyID: string; isFirstClaim?: boolean }
): Promise<boolean> => {
  const { sleepStudyID, isFirstClaim } = payload;
  const url = `${rootState.env?.requestUrl.events}/studies/${sleepStudyID}/claim`;
  const { setError } = useGlobalErrorOverlay();
  const { t } = i18n.global;

  try {
    isFirstClaim ? await axiosInstance.post<SafeAny>(url) : await axiosInstance.patch<SafeAny>(url);

    return true;
  } catch ({ response }: SafeAny) {
    setError(t(response?.data?.error?.code || 'errorAuthorization'), t('genericAccessError'), true);

    return false;
  }
};
